export const ROOT = 'StepOne/form/yearVehicle';

export const FETCH_VEHICLE_YEAR_REQUEST = `${ROOT}/FETCH_VEHICLE_YEAR_REQUEST`;
export const FETCH_VEHICLE_YEAR_FAILURE = `${ROOT}/FETCH_VEHICLE_YEAR_FAILURE`;
export const FETCH_VEHICLE_YEAR_SUCCESS = `${ROOT}/FETCH_VEHICLE_YEAR_SUCCESS`;
